export default __webpack_public_path__ + "static/media/1832.7d6174ed.png";